import React from 'react';
import Tooltip from '../../../components/Tooltip';

const IntegrationButton = ({ label, handleClick, Icon }) => {
  return (
    <Tooltip color={'text-gray-500'} text={label}>
      <button
        onClick={handleClick}
        className="shadow-sm flex flex-col items-center justify-center p-1 border border-primary-200 transition hover:bg-primary-100 rounded-xl">
        <Icon className="text-orange-500 w-7 h-7" />
      </button>
    </Tooltip>
  );
};
export default IntegrationButton;
